import React from 'react'
import { Icon } from './Edit.elements'

type Props = {
  className?: string
}

export const EditIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 16 17"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <path d="M3.5 14.5h9M5 9l-.333 2.5L7.25 11l5-6.5-1.125-.875L10 2.75 5 9z" stroke="currentColor" strokeWidth="2" strokeLinecap="square" />
    <path d="M10.026 7.268l.768.64 1.28-1.536-.767-.64-1.28 1.536zm-.72-3.203a1 1 0 00-1.28 1.536l1.28-1.536zm2 1.667l-2-1.667-1.28 1.536 2 1.667 1.28-1.536z" fill="currentColor" />
  </Icon>
)
